module.exports = __webpack_public_path__ + "static/img/index.8b6e288.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/index.png
// module id = q+Rq
// module chunks = 1